import { type ReactNode } from 'react';
import { Modal } from '@/components/ui/Modal/Modal';
import { Button } from '@/components/ui/Button/Button';
import './ChoiceDialog.css';

export type ChoiceDialogActionVariant =
  | 'primary'
  | 'secondary'
  | 'outlined'
  | 'danger'
  | 'dangerOutline'
  | 'warning';

export interface ChoiceDialogAction {
  label: string;
  onClick: () => void;
  variant?: ChoiceDialogActionVariant;
  disabled?: boolean;
}

interface ChoiceDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: ReactNode;
  /** Ширина модалки (класс Modal); на экране не шире 95vw, см. ChoiceDialog.css. */
  size?: 'sm' | 'md' | 'ml' | 'lg';
  /** Кнопки слева направо; первая обычно «Отмена» (outlined / secondary). */
  actions: ChoiceDialogAction[];
}

export function ChoiceDialog({
  open,
  onClose,
  title,
  description,
  size = 'sm',
  actions,
}: ChoiceDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size={size}
      className="choice-dialog-modal"
      headerVariant="island"
      scrollableBody={false}
      overlayClassName="choice-dialog-overlay"
    >
      <div className="choice-dialog">
        <div className="choice-dialog__description">{description}</div>
        <div className="form__footer form__footer_modal">
          {actions.map((action, index) => (
            <Button
              key={`${action.label}-${index}`}
              type="button"
              variant={action.variant ?? 'primary'}
              size="m"
              disabled={action.disabled}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </div>
      </div>
    </Modal>
  );
}
